/* eslint-disable react/no-access-state-in-setstate */
import React from 'react';

import Section from 'react-scale/components/elements/section';
import FeatureTitle from 'react-scale/components/pages/open-datasets/FeatureTitle';
import LidarIframe from 'react-scale/components/website/index/Products/examples/LidarIframe';

import { mq } from 'react-scale/components/website/big/Themes';
import Spinner from 'react-scale/components/elements/spinner';

export default class DataAnnotation extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      scene: this.props.scenes[0],
      sceneActive: 0,
      annotationsByLabel: [],
      frame: this.props.scenes[0].frame,
      hideAnnotationsByLabel: []
    };
  }

  updateSelect = ev => {
    const sceneActive = parseInt(ev.target.value, 10);
    const scene = this.props.scenes[sceneActive];
    this.setState({
      sceneActive,
      scene,
      frame: scene.frame,
      annotationsByLabel: [],
      hideAnnotationsByLabel: []
    });
  };

  updateAnnotations = annotations => {
    const annotationsByLabel = annotations.map(annotationsByFrame =>
      annotationsByFrame.cuboids.reduce((acc, cuboid) => {
        if (acc[cuboid.label]) {
          acc[cuboid.label].count += 1;
        } else {
          acc[cuboid.label] = { count: 1, color: cuboid.color };
        }
        return acc;
      }, {})
    );

    this.setState({ annotationsByLabel });
  };

  updateFrame = frame => {
    this.setState({ frame });
  };

  updateHideAnnotationsByLabel = label => {
    if (this.state.hideAnnotationsByLabel.includes(label)) {
      this.setState({
        hideAnnotationsByLabel: this.state.hideAnnotationsByLabel.filter(
          labelItem => labelItem !== label
        )
      });
    } else {
      this.setState({
        hideAnnotationsByLabel: [...this.state.hideAnnotationsByLabel, label]
      });
    }
  };

  render() {
    const { activeItemColor, iconColors, overtitle, title, text, caseColor } = this.props;
    const { scene, annotationsByLabel, frame } = this.state;
    const annotationItems = annotationsByLabel[frame] && Object.keys(annotationsByLabel[frame]);
    return (
      <Section id="data-annotation">
        <FeatureTitle
          iconSVG={<Icon colors={iconColors} />}
          overtitle={overtitle}
          title={title}
          subtitle={text}
          caseColor={caseColor}
        />
        <article>
          {this.props.children}
          <div className="lidar">
            <div className="left-column">
              <div className="select-wrapper">
                <div className="select-info">
                  <span>{scene.title}</span>
                  <svg width="8" height="16" viewBox="0 0 8 16" fill="none">
                    <path
                      d="M0.646447 3.51008C0.451184 3.70535 0.451184 4.02193 0.646447 4.21719C0.841709 4.41245 1.15829 4.41245 1.35355 4.21719L0.646447 3.51008ZM3.86364 1L4.21719 0.646447C4.02193 0.451184 3.70535 0.451184 3.51008 0.646447L3.86364 1ZM6.37372 4.21719C6.56898 4.41245 6.88556 4.41245 7.08083 4.21719C7.27609 4.02193 7.27609 3.70535 7.08083 3.51008L6.37372 4.21719ZM1.35355 11.7828C1.15829 11.5875 0.841709 11.5875 0.646447 11.7828C0.451184 11.9781 0.451184 12.2947 0.646447 12.4899L1.35355 11.7828ZM3.86364 15L3.51008 15.3536C3.70535 15.5488 4.02193 15.5488 4.21719 15.3536L3.86364 15ZM7.08083 12.4899C7.27609 12.2947 7.27609 11.9781 7.08083 11.7828C6.88556 11.5875 6.56898 11.5875 6.37372 11.7828L7.08083 12.4899ZM1.35355 4.21719L4.21719 1.35355L3.51008 0.646447L0.646447 3.51008L1.35355 4.21719ZM3.51008 1.35355L6.37372 4.21719L7.08083 3.51008L4.21719 0.646447L3.51008 1.35355ZM0.646447 12.4899L3.51008 15.3536L4.21719 14.6464L1.35355 11.7828L0.646447 12.4899ZM4.21719 15.3536L7.08083 12.4899L6.37372 11.7828L3.51008 14.6464L4.21719 15.3536Z"
                      fill="#404040"
                    />
                  </svg>
                </div>
                <select onChange={this.updateSelect} value={this.state.sceneActive}>
                  {this.props.scenes.map((sceneItem, i) => (
                    <option key={sceneItem.title} value={i}>
                      {sceneItem.title}
                    </option>
                  ))}
                </select>
              </div>
              <div className="scenes-overflow">
                {(!annotationItems || annotationItems.length === 0) && <Spinner />}
                {annotationItems && annotationItems.length > 0 && (
                  <ul>
                    {annotationItems.map(label => (
                      <AnnotationItem
                        id={annotationsByLabel[frame][label].count}
                        name={label}
                        color={annotationsByLabel[frame][label].color}
                        key={label}
                        onClick={() => {
                          this.updateHideAnnotationsByLabel(label);
                        }}
                        itemHoverColor={activeItemColor}
                        disabled={this.state.hideAnnotationsByLabel.includes(label)}
                      />
                    ))}
                  </ul>
                )}
              </div>
            </div>
            <div className="iframe-wrapper">
              <LidarIframe
                zoid
                title={scene.title}
                frames={scene.frames}
                annotations={scene.annotations}
                showImages={scene.showImages}
                frame={scene.frame}
                updateAnnotations={this.updateAnnotations}
                updateFrame={this.updateFrame}
                hideAnnotationsByLabel={this.state.hideAnnotationsByLabel}
              />
            </div>
          </div>
        </article>
        <style jsx>{`
          .lidar {
            background: black;
            margin: 4rem 0 0;
            padding: 0 0 calc(4rem / 2);
            display: grid;
            grid-template-columns: 1fr;
            grid-gap: calc(4rem / 2);
            position: relative;
            z-index: 3;
            overflow: hidden;
          }
          @media (min-width: ${mq.md}) {
            .lidar {
              padding: calc(4rem / 2);
            }
          }
          @media (min-width: ${mq.lg}) {
            .lidar {
              grid-template-columns: 390px 1fr;
            }
          }
          .lidar .left-column {
            display: flex;
            flex-direction: column;
          }
          @media (min-width: ${mq.lg}) {
            .lidar .left-column {
              overflow: hidden;
              height: 46.8vw;
            }
          }
          .lidar .scenes-overflow {
            background: #ffffff;
            height: 100%;
            overflow: hidden;
          }
          .lidar ul {
            height: 260px;
            margin: 0;
            padding: 0;
            list-style: none;
            overflow: scroll;
          }
          @media (min-width: ${mq.lg}) {
            .lidar ul {
              height: 100%;
            }
          }
          .lidar .iframe-wrapper {
            width: 100%;
            height: 512px;
            position: relative;
            overflow: hidden;
          }
          @media (min-width: ${mq.md}) {
            .lidar .iframe-wrapper {
              height: 46.8vw;
            }
          }
          .lidar .select-info {
            background: ${activeItemColor};
            height: 80px;
            padding: 0 calc(4rem / 2);
            display: flex;
            justify-content: space-between;
            align-items: center;
          }
          @media (min-width: ${mq.md}) {
            .lidar .select-info {
              font-size: 1.6rem;
            }
          }
          .lidar .select-grid {
            display: flex;
            align-items: center;
            justify-content: center;
          }
          @media (min-width: ${mq.lg}) {
            .lidar .select-grid {
              display: none;
            }
          }
          .lidar .select-wrapper {
            position: relative;
            margin: 0 0 calc(4rem / 2);
          }
          .lidar .select-wrapper select {
            height: 100%;
            width: 100%;
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            opacity: 0;
            z-index: 2;
            cursor: pointer;
          }
        `}</style>
      </Section>
    );
  }
}

DataAnnotation.defaultProps = {
  overtitle: { text: 'Data Annotation' },
  title: 'Complex Label Taxonomy'
};

const Icon = ({ colors }) => (
  <svg viewBox="0 0 144 144">
    <path
      d="M72 144C111.765 144 144 111.765 144 72C144 32.2355 111.765 0 72 0C32.2355 0 0 32.2355 0 72C0 111.765 32.2355 144 72 144Z"
      fill="black"
    />
    <path
      d="M91.9823 32.8063L81.9073 22.7313C80.9323 21.7562 79.3573 21.7562 78.3823 22.7313L66.6573 34.4563C66.1823 34.9313 65.9323 35.5563 65.9323 36.2313V46.3063C65.9323 47.6813 67.0573 48.8063 68.4323 48.8063H78.5073C79.1823 48.8063 79.8073 48.5313 80.2823 48.0813L91.2573 37.1063L92.0073 36.3563C92.9573 35.3813 92.9573 33.8063 91.9823 32.8063ZM73.7073 44.5313C72.7323 45.5063 71.1573 45.5063 70.1823 44.5313C69.2073 43.5563 69.2073 41.9813 70.1823 41.0063C71.1573 40.0313 72.7323 40.0313 73.7073 41.0063C74.6823 41.9813 74.6823 43.5563 73.7073 44.5313Z"
      fill={colors[0]}
    />
    <path
      d="M75.555 95.207H65.48C64.805 95.207 64.18 95.482 63.705 95.932L52.73 106.907L51.98 107.657C51.005 108.632 51.005 110.207 51.98 111.182L62.055 121.257C63.03 122.232 64.605 122.232 65.58 121.257L77.305 109.532C77.78 109.057 78.03 108.432 78.03 107.757V97.682C78.055 96.332 76.93 95.207 75.555 95.207ZM73.78 103.007C72.805 103.982 71.23 103.982 70.255 103.007C69.28 102.032 69.28 100.457 70.255 99.482C71.23 98.507 72.805 98.507 73.78 99.482C74.755 100.457 74.755 102.032 73.78 103.007Z"
      fill={colors[0]}
    />
    <path
      d="M58.4076 30.1562H44.1576C42.7826 30.1562 41.6576 31.2812 41.6576 32.6562V49.2312C41.6576 49.9062 41.9326 50.5312 42.3826 51.0062L49.5076 58.1312C50.4826 59.1062 52.0576 59.1062 53.0326 58.1312L60.1576 51.0062C60.6326 50.5312 60.8826 49.9062 60.8826 49.2312V33.7312V32.6562C60.9076 31.2812 59.7826 30.1562 58.4076 30.1562ZM51.2826 53.8562C49.9076 53.8562 48.7826 52.7312 48.7826 51.3562C48.7826 49.9812 49.9076 48.8562 51.2826 48.8562C52.6576 48.8562 53.7826 49.9812 53.7826 51.3562C53.7826 52.7312 52.6576 53.8562 51.2826 53.8562Z"
      fill={colors[1]}
    />
    <path
      d="M102.306 94.7797C102.306 94.1047 102.031 93.4797 101.581 93.0047L94.4557 85.8797C93.4807 84.9047 91.9057 84.9047 90.9307 85.8797L83.8057 93.0047C83.3307 93.4797 83.0807 94.1047 83.0807 94.7797V110.28V111.355C83.0807 112.73 84.2057 113.855 85.5807 113.855H99.8307C101.206 113.855 102.331 112.73 102.331 111.355L102.306 94.7797ZM92.6807 95.1547C91.3057 95.1547 90.1807 94.0297 90.1807 92.6547C90.1807 91.2797 91.3057 90.1547 92.6807 90.1547C94.0557 90.1547 95.1807 91.2797 95.1807 92.6547C95.1807 94.0297 94.0557 95.1547 92.6807 95.1547Z"
      fill={colors[1]}
    />
    <path
      d="M48.0563 63.7297L37.0813 52.7547L36.3313 52.0047C35.3563 51.0297 33.7812 51.0297 32.8063 52.0047L22.7313 62.0797C21.7562 63.0547 21.7562 64.6297 22.7313 65.6047L34.4563 77.3297C34.9313 77.8047 35.5563 78.0547 36.2313 78.0547H46.3063C47.6813 78.0547 48.8063 76.9297 48.8063 75.5547V65.5047C48.7813 64.8297 48.5063 64.2047 48.0563 63.7297ZM44.5063 73.8047C43.5313 74.7797 41.9563 74.7797 40.9813 73.8047C40.0063 72.8297 40.0063 71.2547 40.9813 70.2797C41.9563 69.3047 43.5313 69.3047 44.5063 70.2797C45.4813 71.2547 45.4813 72.8297 44.5063 73.8047Z"
      fill={colors[2]}
    />
    <path
      d="M121.258 78.3797L109.533 66.6547C109.058 66.1797 108.433 65.9297 107.758 65.9297H97.6828C96.3078 65.9297 95.1828 67.0547 95.1828 68.4297V78.5047C95.1828 79.1797 95.4578 79.8047 95.9078 80.2797L106.883 91.2547L107.633 92.0047C108.608 92.9797 110.183 92.9797 111.158 92.0047L121.233 81.9297C122.233 80.9547 122.233 79.3547 121.258 78.3797ZM102.983 73.7297C102.008 74.7047 100.433 74.7047 99.4578 73.7297C98.4828 72.7547 98.4828 71.1797 99.4578 70.2047C100.433 69.2297 102.008 69.2297 102.983 70.2047C103.958 71.1797 103.958 72.7547 102.983 73.7297Z"
      fill={colors[2]}
    />
    <path
      d="M58.1065 90.932L50.9815 83.807C50.5065 83.332 49.8815 83.082 49.2065 83.082H33.7065H32.6315C31.2565 83.082 30.1315 84.207 30.1315 85.582V99.832C30.1315 101.207 31.2565 102.332 32.6315 102.332H49.2065C49.8815 102.332 50.5065 102.057 50.9815 101.607L58.1065 94.482C59.0815 93.507 59.0815 91.907 58.1065 90.932ZM51.3315 95.207C49.9565 95.207 48.8315 94.082 48.8315 92.707C48.8315 91.332 49.9565 90.207 51.3315 90.207C52.7065 90.207 53.8315 91.332 53.8315 92.707C53.8315 94.082 52.7065 95.207 51.3315 95.207Z"
      fill={colors[3]}
    />
    <path
      d="M111.331 41.6797H94.7563C94.0813 41.6797 93.4563 41.9547 92.9813 42.4047L85.8563 49.5297C84.8813 50.5047 84.8813 52.0797 85.8563 53.0547L92.9813 60.1797C93.4563 60.6547 94.0813 60.9047 94.7563 60.9047H110.256H111.331C112.706 60.9047 113.831 59.7797 113.831 58.4047V44.1547C113.831 42.8047 112.706 41.6797 111.331 41.6797ZM92.6313 53.8047C91.2563 53.8047 90.1313 52.6797 90.1313 51.3047C90.1313 49.9297 91.2563 48.8047 92.6313 48.8047C94.0063 48.8047 95.1313 49.9297 95.1313 51.3047C95.1313 52.6797 94.0063 53.8047 92.6313 53.8047Z"
      fill={colors[3]}
    />
  </svg>
);

const AnnotationItem = ({ id, name, color, onClick, disabled, itemHoverColor }) => (
  <li onClick={onClick}>
    <svg viewBox="0 0 33 35">
      <rect x="0.98584" y="0.470703" width="31.9618" height="33.5423" fill={color} />
      {!disabled && (
        <g clipPath="url(#clip0)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8.97516 16.7408C9.40365 15.8414 10.2606 14.7181 11.7595 15.1677C13.0449 15.6174 13.9012 16.9656 14.5437 18.7643C19.6839 12.6953 23.9672 8.42509 29.1076 7.07617C29.7503 7.07617 29.9645 7.07617 29.5361 7.52585C23.9673 11.5722 18.6129 17.6403 14.3297 25.507C14.1154 25.7319 13.9012 25.7319 13.6869 25.507C12.8299 23.2594 12.188 21.012 11.1168 18.7635C10.6883 17.6393 10.0456 16.7408 8.9751 16.7408L8.97516 16.7408Z"
            fill="black"
          />
        </g>
      )}
      <defs>
        <clipPath id="clip0">
          <rect
            width="20.7752"
            height="21.8025"
            fill="white"
            transform="translate(8.97559 5.50195)"
          />
        </clipPath>
      </defs>
    </svg>
    <div>
      <span>{name}</span>
      <span>{id} annotations</span>
    </div>
    <style jsx>{`
      li {
        color: black;
        background-color: transparent;
        height: 80px;
        padding: 0 calc(4rem / 2);
        border-bottom: 1px solid white;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        transition: all 250ms ease-out;
        cursor: pointer;
        position: relative;
      }
      @media (min-width: ${mq.lg}) {
        li {
          height: 120px;
        }
      }
      li:last-child {
        border: 0;
      }
      li:hover {
        background-color: ${itemHoverColor};
      }

      li:nth-child(7n + 1) svg rect {
        fill: #fed733;
      }

      li:nth-child(7n + 2) svg rect {
        fill: #d5abff;
      }

      li:nth-child(7n + 3) svg rect {
        fill: #fd9d52;
      }

      li:nth-child(7n + 4) svg rect {
        fill: #f792dd;
      }

      li:nth-child(7n + 5) svg rect {
        fill: #97ec4b;
      }

      li:nth-child(7n + 6) svg rect {
        fill: #50deb9;
      }

      li:nth-child(7n + 7) svg rect {
        fill: #8a9ee4;
      }

      div {
        display: flex;
        flex-direction: column;
        overflow: hidden;
        width: 100%;
        padding: 0 0 0 calc(4rem / 2);
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      span {
        font-family: var(--font-family-code);
        font-size: 1.4rem;
        display: block;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      @media (min-width: ${mq.lg}) {
        span {
          font-size: 1.6rem;
        }
      }
      span:last-child {
        color: #666666;
      }

      svg {
        width: 30px;
        flex-shrink: 0;
      }
    `}</style>
  </li>
);
